<template>
  <section class="landing-split">
    <div class="landing-split__media">
      <div class="landing-split__media__link">
        <div class="landing-split__media__img">
          <ModuleImage :imageUrl="image" :placeholderUrl="placeholderImage" :lazyLoad="false"/>
        </div>
      </div>
    </div>
    <div class="section__content landing-split__section__content">
      <div class="landing-split__section__content__inner-wrapper">
        <div class="landing-split__text-content">
          <div class="landing-split__text-content__header">
            <BaseHeading :size="1">{{heading}}</BaseHeading>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SplitSection',
  props: {
    heading: String,
    subHeading: String,
    image: String,
    placeholderImage: String
  }
}
</script>
<style lang="scss" scoped>
  @import "./section-landing-split";
</style>



// WEBPACK FOOTER //
// src/components/SectionLandingSplit/SectionLandingSplit.vue